import React from 'react';
import moment from 'moment';
import { Col, Skeleton, Grid } from 'antd';
import { I18n } from '@aws-amplify/core';
import { Pagination } from '../../../../Pagination';
import { useGetPreventiveMeasuresPaginated } from './hooks/useGetPreventiveMeasuresPaginated';

import * as S from './styles';

const DEFAULT_TOTAL = 0;

const { useBreakpoint } = Grid;

export function TablePaginated(): JSX.Element {
	const { actionPlanDataReview, paginatedActionPlanData, currentPage, limit, setCurrentPage, isLoading } =
		useGetPreventiveMeasuresPaginated();

	const screens = useBreakpoint();

	function handleOnChangePage(page: number): void {
		setCurrentPage(page);
	}

	if (isLoading) {
		return (
			<div style={{ marginTop: '32px' }}>
				<S.CustomTable>
					<thead>
						<tr>
							<th style={{ width: '8%', textAlign: 'center' }}>No. M.C.P</th>
							<th style={{ width: '15%', textAlign: 'center' }}>{I18n.get('Action plan name')}</th>
							<th style={{ width: '20%', textAlign: 'center' }}>
								{I18n.get('Specific administrative corrective and preventive measure')}
							</th>
							{screens.xxl && (
								<th style={{ width: '12%', textAlign: 'center' }}>{I18n.get('Due date')}</th>
							)}
							<th style={{ width: '20%', textAlign: 'center' }}>
								{I18n.get('Specific engineering corrective and preventive measure')}
							</th>
							{screens.xxl && (
								<th style={{ width: '12%', textAlign: 'center' }}>{I18n.get('Due date')}</th>
							)}
						</tr>
					</thead>
					<tbody>
						{[1, 2, 3, 4, 5, 6].map((index) => (
							<tr key={index}>
								<td style={{ textAlign: 'center' }}>
									<Skeleton.Input active size="small" style={{ width: '30px' }} />
								</td>
								<td style={{ textAlign: 'center' }}>
									<Skeleton.Input active size="default" style={{ width: '120px' }} />
								</td>
								<td style={{ textAlign: 'center' }}>
									<Skeleton.Input active size="default" style={{ width: '150px' }} />
								</td>
								{screens.xxl && (
									<td style={{ textAlign: 'center' }}>
										<Skeleton.Input active size="small" style={{ width: '80px' }} />
									</td>
								)}
								<td style={{ textAlign: 'center' }}>
									<Skeleton.Input active size="default" style={{ width: '150px' }} />
								</td>
								{screens.xxl && (
									<td style={{ textAlign: 'center' }}>
										<Skeleton.Input active size="small" style={{ width: '80px' }} />
									</td>
								)}
							</tr>
						))}
					</tbody>
				</S.CustomTable>
				<Col span={24} style={{ marginTop: '20px' }}>
					<Skeleton.Input active size="default" style={{ width: '200px', height: '32px' }} />
				</Col>
			</div>
		);
	}

	return (
		<div style={{ marginTop: '32px' }}>
			<S.CustomTable>
				<thead>
					<tr>
						<th style={{ width: '8%', textAlign: 'center' }}>No. M.C.P</th>
						<th style={{ width: '15%', textAlign: 'center' }}>{I18n.get('Action plan name')}</th>
						<th style={{ width: '20%', textAlign: 'center' }}>
							{I18n.get('Specific administrative corrective and preventive measure')}
						</th>
						{screens.xxl && <th style={{ width: '12%', textAlign: 'center' }}>{I18n.get('Due date')}</th>}
						<th style={{ width: '20%', textAlign: 'center' }}>
							{I18n.get('Specific engineering corrective and preventive measure')}
						</th>
						{screens.xxl && <th style={{ width: '12%', textAlign: 'center' }}>{I18n.get('Due date')}</th>}
					</tr>
				</thead>
				<tbody>
					{paginatedActionPlanData.map((item) => (
						<tr key={item.number}>
							<td style={{ textAlign: 'center' }}>{item.number}</td>
							<td style={{ textAlign: 'center' }}>{item.actionPlanName}</td>
							<td style={{ textAlign: 'center' }}>{item.administrativeMeasure}</td>
							{screens.xxl && (
								<td style={{ textAlign: 'center' }}>
									{item?.administrativeDueDate
										? moment(item.administrativeDueDate).format('DD/MM/YYYY')
										: '-'}
								</td>
							)}
							<td style={{ textAlign: 'center' }}>{item.engineeringMeasure}</td>
							{screens.xxl && (
								<td style={{ textAlign: 'center' }}>
									{item.engineeringDueDate
										? moment(item.engineeringDueDate).format('DD/MM/YYYY')
										: '-'}
								</td>
							)}
						</tr>
					))}
				</tbody>
			</S.CustomTable>
			<Col span={24} style={{ marginTop: '20px' }}>
				<Pagination
					total={actionPlanDataReview.length || DEFAULT_TOTAL}
					limit={limit}
					currentPage={currentPage}
					onChangePage={handleOnChangePage}
					style={{ justifyContent: 'space-between', width: '100%' }}
				/>
			</Col>
		</div>
	);
}
